/* Upgrade photos baked in as data URIs so the theme needs no image uploads. */
window.MSCB_IMAGES = window.MSCB_IMAGES || {
  handlesRubber: "data:image/avif;base64,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",
  handlesStandard: "data:image/avif;base64,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"
};

/* Custom Hot Tub Cover Builder — Master Spas Pool & Spa Online
   Drives the markup in page/cover-builder.html and the generated
   sections/custom-cover-builder.liquid. No dependencies, no build step.

   Pricing is an ESTIMATE model (see PRICE below). To go live against real
   Shopify pricing, set window.MSCB_VARIANT_ID and window.MSCB_PRICE_TABLE
   before this file loads — see the notes above addToCart(). */
(function () {
  'use strict';

  var $ = function (id) { return document.getElementById(id); };
  if (!$('shapes')) return; // section not on this page

  /* Whole dollars stay clean; the $9.99 / $19.99 skirt tiers keep their cents. */
  var money = function (n) {
    var r = Math.round(n * 100) / 100;
    return '$' + r.toLocaleString('en-US', {
      minimumFractionDigits: r % 1 === 0 ? 0 : 2,
      maximumFractionDigits: 2
    });
  };
  var plus = function (n) { return n > 0 ? '+' + money(n) : 'Included'; };

  /* ------------------------------------------------------------------ data */

  var SHAPE_ICON = function (inner) {
    return '<svg width="54" height="38" viewBox="0 0 54 38" aria-hidden="true">' +
      '<g fill="#e9eff7" stroke="#113C74" stroke-width="2">' + inner + '</g></svg>';
  };

  /* Shapes match the picker on the storefront: round, square and rectangle each
     in a sharp-corner and a radiused-corner version, plus octagon. `radius:true`
     is what reveals the corner-radius field in step 2. */
  /* `oblong: true` marks the shapes that should not render as a square — picking
     one nudges the depth so the preview actually looks like that shape. */
  var SHAPES = [
    { id: 'square-r', name: 'Square, rounded',    radius: true,  factor: 1, lockB: true,
      icon: SHAPE_ICON('<rect x="10" y="2" width="34" height="34" rx="8"/>') },
    { id: 'round',    name: 'Round',              radius: false, factor: 0.82, lockB: true,
      icon: SHAPE_ICON('<circle cx="27" cy="19" r="17"/>') },
    { id: 'square',   name: 'Square',             radius: false, factor: 1, lockB: true,
      icon: SHAPE_ICON('<rect x="10" y="2" width="34" height="34"/>') },
    { id: 'rect',     name: 'Rectangle',          radius: false, factor: 1, oblong: true,
      icon: SHAPE_ICON('<rect x="2" y="6" width="50" height="26"/>') },
    { id: 'rect-r',   name: 'Rectangle, rounded', radius: true,  factor: 1, oblong: true,
      icon: SHAPE_ICON('<rect x="2" y="6" width="50" height="26" rx="7"/>') },
    { id: 'octagon',  name: 'Octagon',            radius: false, factor: 0.88, lockB: true,
      icon: SHAPE_ICON('<polygon points="17,2 37,2 52,12 52,26 37,36 17,36 2,26 2,12"/>') }
  ];

  var TAPERS = [
    { id: '4-2.5', name: '4" – 2.5"', note: 'Mild climates',      add: 0,  c: 4, e: 2.5 },
    { id: '5-3',   name: '5" – 3"',   note: 'Best seller',        add: 50, c: 5, e: 3   },
    { id: '6-4',   name: '6" – 4"',   note: 'Snow load / best R',  add: 75, c: 6, e: 4   }
  ];

  var DENSITY = [
    { id: '1.5', name: '1.5 lb', note: 'Standard', add: 0 },
    { id: '2.0', name: '2.0 lb', note: 'Commercial grade', add: 45 }
  ];

  /* Colors and hex values are read off the Core Covers standard swatch chart
     (corecovers.com/pages/material-colors). They are sampled from photographs
     of real fabric, so several of the darker browns sit close together — that
     is the actual assortment, not a rendering artefact. */
  var MATERIALS = [
    { id: 'vinyl', name: 'Vinyl', add: 0, colors: [
      { id: 'charcoal',     name: 'Charcoal',     hex: '#3a3a36' },
      { id: 'cajun-rust',   name: 'Cajun Rust',   hex: '#602518' },
      { id: 'hunter-green', name: 'Hunter Green', hex: '#16291e' },
      { id: 'bourbon',      name: 'Bourbon',      hex: '#491f13' },
      { id: 'black',        name: 'Black',        hex: '#181714' },
      { id: 'tan',          name: 'Tan',          hex: '#966b3c' },
      { id: 'mocha',        name: 'Mocha',        hex: '#2b190f' },
      { id: 'sky-blue',     name: 'Sky Blue',     hex: '#387682' },
      { id: 'oxen',         name: 'Oxen',         hex: '#5a4431' },
      { id: 'navy',         name: 'Navy',         hex: '#101624' },
      { id: 'gray',         name: 'Gray',         hex: '#7d7e76' },
      { id: 'coastal-gray', name: 'Coastal Gray', hex: '#575655' },
      { id: 'parchment',    name: 'Parchment',    hex: '#574839' },
      { id: 'walnut',       name: 'Walnut',       hex: '#2c1815' },
      { id: 'mahogany',     name: 'Mahogany',     hex: '#382018' },
      { id: 'mayan-brown',  name: 'Mayan Brown',  hex: '#4c2916' },
      { id: 'wildwood',     name: 'Wildwood',     hex: '#632f19' },
      { id: 'sand',         name: 'Sand',         hex: '#c9b689' }
    ]},
    { id: 'weathershield', name: 'WeatherShield™', add: 125, colors: [
      { id: 'ws-desert-taupe', name: 'Desert Taupe', hex: '#a48c76' },
      { id: 'ws-mahogany',     name: 'Mahogany',     hex: '#2d1a12' },
      { id: 'ws-gray',         name: 'Gray',         hex: '#403b36' },
      { id: 'ws-brown',        name: 'Brown',        hex: '#391d18' },
      { id: 'ws-black',        name: 'Black',        hex: '#0a0905' }
    ]}
  ];

  var VAPOR = [
    { id: 'std',        name: 'Standard 4 mil',   note: 'Included',         add: 0 },
    { id: 'commercial', name: 'Commercial 8 mil', note: 'Double wrap', add: 45 }
  ];

  var STOPPER = [
    { id: 'std',  name: 'Standard',    note: '', add: 0 },
    { id: 'full', name: 'Full length', note: '', add: 35 }
  ];

  var HANDLES = [
    { id: 'std',    name: '2 standard handles',         note: 'Reinforced vinyl', add: 0,  count: 2 },
    { id: 'rubber', name: '2 commercial rubber handles', note: 'Heavy duty',       add: 25, count: 2 }
  ];

  var FOLDS = [
    { id: 'ab', name: 'A→B', note: 'Fold across the A side', axis: 'a' },
    { id: 'ba', name: 'B→A', note: 'Fold across the B side', axis: 'b' }
  ];

  /* Straps are a layout choice, not an upgrade: locking keyed buckles and the
     9.5" length are standard on every cover. Sides run clockwise from the front,
     so A and C are opposite each other, as are B and D. */
  var STRAPS = [
    { id: 'ac',      name: 'Option A', note: 'Two straps each on sides A and C', sides: ['A', 'C'] },
    { id: 'bd',      name: 'Option B', note: 'Two straps each on sides B and D', sides: ['B', 'D'] },
    { id: 'corners', name: 'Option C', note: 'One strap at each corner',   corners: true }
  ];

  /* Oversize surcharge, taken from the stock cover catalogue on this store.
     Every stock cover whose longest side is 94" or less sells for one flat
     price no matter its area (52x86 and 94x94 are both $599.99). Price only
     steps when a side passes 94", which is where covers stop being a single
     piece. These surcharges are the catalogue's own steps above that $599.99
     band, so custom pricing lines up with what the shelf products already do. */
  var SIZE_TIERS = [
    { key: null,          upTo: 94,  fee: 0,    label: 'Standard size',      pieces: 1 },
    { key: 'size:120',    upTo: 120, fee: 400,  label: 'Oversize 95"–120"',  pieces: 2 },
    { key: 'size:174',    upTo: 174, fee: 650,  label: 'Oversize 121"–174"', pieces: 2 },
    { key: 'size:201',    upTo: 201, fee: 750,  label: 'Oversize 175"–201"', pieces: 3 },
    { key: 'size:240',    upTo: 240, fee: 1600, label: 'Oversize 202"–240"', pieces: 3 }
  ];

  /* Longest side decides the tier — a 120x94 and a 120x120 are both limited by
     the same 120" span, which is what drives the extra seam and handling. */
  function sizeTier() {
    var shape = find(SHAPES, S.shape);
    var longest = Math.max(S.a, shape.lockB ? S.a : S.b);
    for (var i = 0; i < SIZE_TIERS.length; i++) if (longest <= SIZE_TIERS[i].upTo) return SIZE_TIERS[i];
    return SIZE_TIERS[SIZE_TIERS.length - 1];
  }

  var DELIVERY = [
    { id: 'standard', name: 'Standard', note: '7–9 weeks', add: 0 },
    { id: 'express',  name: 'Express',  note: '3–5 weeks', add: 50 }
  ];

  var INCLUDED = [
    'Reinforced hem',
    'Marine-grade UV thread',
    'Heat-sealed foam wrap',
    'Locking keyed strap buckles',
    '9.5" tie-down straps',
    '3 year limited warranty',
    'Free shipping (lower 48)'
  ];

  var CDN = 'https://cdn.shopify.com/s/files/1/0613/6489/5788/files/';

  /* Upgrade photos. The Liquid section passes real asset_url paths in here; the
     standalone preview passes data URIs. If neither is present the comparison
     modals fall back to their drawn diagrams, so nothing ever renders empty. */
  var IMG = window.MSCB_IMAGES || {};

  /* ------------------------------------------------------------- Shopify

     Every price the builder shows comes from Shopify itself. On load it fetches
     the product JSON for the cover and the upgrades, caches variant prices, and
     prices the build from those. Nothing is hard-coded, so the number on screen
     can never drift from what checkout charges.

     Until upgrade variant ids are filled in below, the builder falls back to the
     estimate model and keeps the "EST pricing" badge. Override any of this by
     defining window.MSCB_SHOPIFY before this file loads. */
  var SHOP = window.MSCB_SHOPIFY || {
    coverHandle: 'custom-hot-tub-covers',

    /* Taper tier -> the cover variant that carries the base price. These three
       ids are the live Standard / Deluxe / Extreme variants. */
    taperVariant: {
      '4-2.5': 44783746646060,   // Standard
      '5-3':   44783746678828,   // Deluxe
      '6-4':   44783746711596    // Extreme
    },

    /* One product holding every paid add-on, one variant each. Create it in
       admin, then paste the variant ids here. Any left null simply falls back
       to the estimate price for that option. */
    upgradesHandle: 'cover-upgrades',
    upgradeVariant: {
      'density:2.0':            45934731427884,   // 2.0 lb commercial foam
      'material:weathershield': 45934731460652,   // WeatherShield fabric
      'vapor:commercial':       45934731493420,   // Commercial 8 mil vapor barrier
      'stopper:full':           45934731526188,   // Full length steam stopper
      'handles:rubber':         45934731558956,   // Commercial rubber handles
      'skirt:tier1':            45934731591724,   // Skirt over 5" up to 7"
      'skirt:tier2':            45934731624492,   // Skirt over 7"
      'delivery:express':       45934731657260,   // Express production
      'size:120':               45934731690028,   // Oversize 95"-120"
      'size:174':               45934731722796,   // Oversize 121"-174"
      'size:201':               45934731755564,   // Oversize 175"-201"
      'size:240':               45934731788332    // Oversize 202"-240"
    }
  };

  /* variantId -> price in dollars, filled in by loadLivePrices() */
  var LIVE = {};
  var livePricesLoaded = false;

  /* True once we have a real price for the base cover. Upgrades fall back
     individually, so a half-configured store still prices correctly. */
  function liveMode() {
    return livePricesLoaded && LIVE[SHOP.taperVariant[S.taper]] != null;
  }

  function upgradePrice(key, fallback) {
    var id = SHOP.upgradeVariant[key];
    return (id && LIVE[id] != null) ? LIVE[id] : fallback;
  }

  function fetchProduct(handle) {
    if (!handle || typeof fetch !== 'function') return Promise.resolve(null);
    return fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  function loadLivePrices() {
    /* Lifters are separate products, so fetch each one as well — otherwise a
       price change in admin would leave the builder quoting a stale number. */
    var handles = [SHOP.coverHandle, SHOP.upgradesHandle].concat(
      LIFTERS.map(function (l) { return l.url ? l.url.split('/').pop() : null; })
    ).filter(Boolean);

    return Promise.all(handles.map(fetchProduct))
      .then(function (products) {
        products.filter(Boolean).forEach(function (p) {
          p.variants.forEach(function (v) { LIVE[v.id] = v.price / 100; });
        });
        livePricesLoaded = Object.keys(LIVE).length > 0;
        if (livePricesLoaded) {
          var badge = $('priceMode');
          if (badge) {
            badge.textContent = liveMode() ? 'LIVE pricing' : 'EST pricing';
            badge.title = liveMode()
              ? 'Prices read directly from this store'
              : 'Base cover variant not found — showing estimates';
          }
          update();
        }
      });
  }

  /* Real products from the store, with live prices, images and variant ids
     captured from masterspapartsonline.com. `desc` is deliberately short — the
     product pages themselves currently carry no description copy, so the card
     links through rather than inventing fitment or clearance claims. */
  var LIFTERS = [
    { id: 'cvpro', name: 'Cover Valet PRO', price: 299.99, variantId: 43741511581740,
      url: '/products/master-spa-cvpro-cover-valet-pro-hot-tub-cover-lifter',
      desc: 'Cover Valet’s full-size PRO lifter. Check the product page for cabinet fitment and clearance.',
      art: CDN + 'Untitled_design_37.png?v=1737580326&width=420' },
    { id: 'caddy', name: 'Cover Caddy', price: 329.99, variantId: 43741510697004,
      url: '/products/master-spa-cv90203-cover-valet-caddy-hot-tub-cover-lifter',
      desc: 'Cover Valet Caddy. A swim-spa extension kit is available separately if you need the extra span.',
      art: CDN + 'Untitled_design_39.png?v=1737580551&width=420' },
    { id: 'ezlift', name: 'Master Spa EZ Lift', price: 329.99, variantId: 44028818587692,
      url: '/products/master-lift-ez-cover-lifter',
      desc: 'Master Lift EZ assisted lifter (X619216) — the factory Master Spas option.',
      art: CDN + 'Untitled_design_29.png?v=1743540097&width=420' }
  ];

  /* Use the real photo when the theme supplied one, otherwise the diagram. */
  function art(key, fallback, alt) {
    return IMG[key]
      ? '<img src="' + IMG[key] + '" alt="' + alt + '" loading="lazy">'
      : fallback;
  }

  var COMPARE = {
    stopper: {
      title: 'Steam stopper — standard vs full length',
      items: [
        { art: cmpArt(false), h: 'Standard (included)',
          p: 'A foam pillow at each end of the hinge. The ends are where the fold opens up widest, so the pillows plug the two biggest gaps — but the length of the fold in between is left open.' },
        { art: cmpArt(true), h: 'Full length (+$35)',
          p: 'One continuous seal running the full width of the cover along the fold, rather than two pillows at the ends. Nothing escapes through the middle of the hinge, so you keep noticeably more heat in and the heater cycles less.' }
      ]
    },
    handles: {
      title: 'Handles — standard vs commercial rubber',
      items: [
        { art: art('handlesStandard', handleArt(false), 'Standard stitched vinyl handle'), h: '2 standard handles (included)',
          p: 'Reinforced vinyl loops stitched into the hem, in the same material as the cover. They sit flat, match the colour exactly, and are what the great majority of covers ship with.' },
        { art: art('handlesRubber', handleArt(true), 'Commercial moulded rubber handle'), h: '2 commercial rubber handles (+$25)',
          p: 'Moulded rubber grips rather than sewn vinyl. They hold their shape instead of flattening out, stay grippable with wet hands, and take the strain far better on a thick 6" core — which is where stitched vinyl handles eventually tear away.' }
      ]
    }
  };

  /* The cover seen from above, both halves of the bifold with the hinge running
     between them. Standard puts a pillow at each end of that hinge; full length
     seals the whole span. */
  function cmpArt(full) {
    var seal = full
      ? '<rect x="26" y="53" width="148" height="14" rx="7" fill="#FF7E00"/>' +
        '<text x="100" y="104" font-size="11.5" font-weight="700" fill="#0c6b3d" ' +
          'text-anchor="middle">sealed the full width</text>'
      : '<rect x="26" y="53" width="26" height="14" rx="7" fill="#FF7E00"/>' +
        '<rect x="148" y="53" width="26" height="14" rx="7" fill="#FF7E00"/>' +
        '<text x="100" y="104" font-size="11.5" font-weight="700" fill="#113C74" ' +
          'text-anchor="middle">a pillow at each end</text>';
    return '<svg viewBox="0 0 200 120" preserveAspectRatio="xMidYMid meet">' +
      '<rect width="200" height="120" fill="#eef3f9"/>' +
      '<rect x="26" y="18" width="148" height="35" rx="4" fill="#113C74"/>' +
      '<rect x="26" y="67" width="148" height="35" rx="4" fill="#113C74"/>' +
      '<line x1="26" y1="60" x2="174" y2="60" stroke="#7d8896" stroke-width="1.5" stroke-dasharray="5 4"/>' +
      seal + '</svg>';
  }

  /* Left: a flat stitched vinyl loop. Right: a thicker moulded rubber grip with
     a visible bolt-through plate, so the difference reads at a glance. */
  function handleArt(rubber) {
    var grip = rubber
      ? '<rect x="62" y="52" width="76" height="26" rx="13" fill="#2b2f36" stroke="#12151a" stroke-width="2"/>' +
        '<rect x="74" y="60" width="52" height="10" rx="5" fill="#4a5058"/>' +
        '<circle cx="58" cy="65" r="5" fill="#8a949f"/><circle cx="142" cy="65" r="5" fill="#8a949f"/>' +
        '<text x="100" y="104" font-size="12" font-weight="700" fill="#0c6b3d" text-anchor="middle">moulded rubber</text>'
      : '<path d="M66,70 q34,-26 68,0" fill="none" stroke="#3a3a36" stroke-width="9" stroke-linecap="round"/>' +
        '<path d="M66,70 q34,-26 68,0" fill="none" stroke="#8a949f" stroke-width="1.4" stroke-dasharray="4 4"/>' +
        '<text x="100" y="104" font-size="12" font-weight="700" fill="#113C74" text-anchor="middle">stitched vinyl</text>';
    return '<svg viewBox="0 0 200 120" preserveAspectRatio="xMidYMid meet">' +
      '<rect width="200" height="120" fill="#eef3f9"/>' +
      '<rect x="30" y="74" width="140" height="14" rx="3" fill="#cbd7e6" stroke="#113C74" stroke-width="2"/>' +
      grip + '</svg>';
  }

  /* ----------------------------------------------------------------- state */

  var S = {
    shape: 'square-r', a: 84, b: 84, rad: 6, skirt: 5, cutouts: false,
    taper: '5-3', density: '1.5',
    material: 'vinyl', color: 'charcoal',
    vapor: 'std', stopper: 'std', handles: 'std',
    fold: 'ab', straps: 'ac',
    delivery: 'standard', lifter: null,
    okDims: false, okReturns: false
  };

  /* LIFTERS has no "none" entry any more, so an unset lifter must return null
     rather than falling through to the first product in the list. */
  function currentLifter() {
    if (!S.lifter) return null;
    for (var i = 0; i < LIFTERS.length; i++) if (LIFTERS[i].id === S.lifter) return LIFTERS[i];
    return null;
  }

  var find = function (list, id) {
    for (var i = 0; i < list.length; i++) if (list[i].id === id) return list[i];
    return list[0];
  };

  /* ----------------------------------------------------------------- price */

  /* Estimate only. Area-driven base plus flat adders per option.
     Override any of these by defining window.MSCB_PRICE_TABLE. */
  var PRICE = window.MSCB_PRICE_TABLE || {
    setup: 245,     // fixed per-cover build cost
    perSqFt: 7.5,   // material + labour per square foot of cover
    cutoutFee: 0,   // quoted after order — see cutoutNote()
    // Skirt is free up to the 5" standard, then two flat tiers.
    skirtTiers: [
      { upTo: 5,        fee: 0 },
      { upTo: 7,        fee: 10 },
      { upTo: Infinity, fee: 20 }
    ]
  };

  /* Flat fee for the chosen skirt length. 5" and under is included; over 5"
     through 7" is one tier; anything over 7" is the next. */
  function skirtFee() {
    var tiers = PRICE.skirtTiers;
    for (var i = 0; i < tiers.length; i++) if (S.skirt <= tiers[i].upTo) return tiers[i].fee;
    return tiers[tiers.length - 1].fee;
  }

  function areaSqFt() {
    var shape = find(SHAPES, S.shape);
    var a = S.a, b = shape.lockB ? S.a : S.b;
    if (S.shape === 'round') return Math.PI * (a / 2) * (a / 2) / 144;
    return (a * b / 144) * shape.factor;
  }

  /* Which upgrade key, if any, each choice maps to. Keeps the pricing and the
     cart build reading from one place. */
  function skirtTierKey() {
    var fee = skirtFee();
    return fee === 0 ? null : (S.skirt <= 7 ? 'skirt:tier1' : 'skirt:tier2');
  }

  function chosenUpgrades() {
    var out = [];
    if (S.density === '2.0')            out.push({ key: 'density:2.0',            fallback: find(DENSITY, '2.0').add });
    if (S.material === 'weathershield') out.push({ key: 'material:weathershield', fallback: find(MATERIALS, 'weathershield').add });
    if (S.vapor === 'commercial')       out.push({ key: 'vapor:commercial',       fallback: find(VAPOR, 'commercial').add });
    if (S.stopper === 'full')           out.push({ key: 'stopper:full',           fallback: find(STOPPER, 'full').add });
    if (S.handles === 'rubber')         out.push({ key: 'handles:rubber',         fallback: find(HANDLES, 'rubber').add });
    if (S.delivery === 'express')       out.push({ key: 'delivery:express',       fallback: find(DELIVERY, 'express').add });
    var sk = skirtTierKey();
    if (sk) out.push({ key: sk, fallback: skirtFee() });
    var sz = sizeTier();
    if (sz.key) out.push({ key: sz.key, fallback: sz.fee });
    return out;
  }

  function priceOf(key, fallback) { return upgradePrice(key, fallback); }

  function priceLines() {
    var mat = find(MATERIALS, S.material);
    var lift = currentLifter();

    /* Live: the base cover variant price already includes the taper tier, and
       each upgrade is priced by its own variant. */
    if (liveMode()) {
      return {
        base:     LIVE[SHOP.taperVariant[S.taper]],
        oversize: sizeTier().key ? priceOf(sizeTier().key, sizeTier().fee) : 0,
        skirt:    skirtTierKey() ? priceOf(skirtTierKey(), skirtFee()) : 0,
        taper:    0,
        density:  S.density === '2.0' ? priceOf('density:2.0', find(DENSITY, '2.0').add) : 0,
        material: S.material === 'weathershield' ? priceOf('material:weathershield', mat.add) : 0,
        vapor:    S.vapor === 'commercial' ? priceOf('vapor:commercial', find(VAPOR, 'commercial').add) : 0,
        stopper:  S.stopper === 'full' ? priceOf('stopper:full', find(STOPPER, 'full').add) : 0,
        handles:  S.handles === 'rubber' ? priceOf('handles:rubber', find(HANDLES, 'rubber').add) : 0,
        delivery: S.delivery === 'express' ? priceOf('delivery:express', find(DELIVERY, 'express').add) : 0,
        lifter:   lift ? (LIVE[lift.variantId] != null ? LIVE[lift.variantId] : lift.price) : 0
      };
    }

    /* Fallback: the area-driven estimate, used before prices load or when the
       cover product cannot be reached. */
    return {
      base: PRICE.setup + areaSqFt() * PRICE.perSqFt,
      oversize: sizeTier().fee,
      skirt: skirtFee(),
      taper: find(TAPERS, S.taper).add,
      density: find(DENSITY, S.density).add,
      material: mat.add,
      vapor: find(VAPOR, S.vapor).add,
      stopper: find(STOPPER, S.stopper).add,
      handles: find(HANDLES, S.handles).add,
      delivery: find(DELIVERY, S.delivery).add,
      lifter: lift ? lift.price : 0
    };
  }

  function total() {
    var p = priceLines(), t = 0, k;
    for (k in p) if (Object.prototype.hasOwnProperty.call(p, k)) t += p[k];
    return t;
  }

  /* ---------------------------------------------------------------- render */

  function paintShapes() {
    $('shapes').innerHTML = SHAPES.map(function (s) {
      return '<div class="shape' + (s.id === S.shape ? ' on' : '') + '" data-id="' + s.id +
        '" role="button" tabindex="0">' + s.icon + '<span>' + s.name + '</span></div>';
    }).join('');
  }

  function paintTapers() {
    $('tapers').innerHTML = TAPERS.map(function (t) {
      return '<div class="tp' + (t.id === S.taper ? ' on' : '') + '" data-id="' + t.id +
        '" role="button" tabindex="0"><div class="tp-art">' + taperArt(t) + '</div>' +
        '<div class="tp-b"><div class="tp-n">' + t.name + '</div>' +
        '<div class="tp-r">' + t.note + '</div>' +
        '<div class="tp-p">' + plus(t.add) + '</div></div></div>';
    }).join('');
  }

  /* Cross-section drawn to scale: 6" of foam = 34px of art. */
  function taperArt(t) {
    var px = 5.2, top = 78;
    var yc = top - t.c * px, ye = top - t.e * px;
    return '<svg viewBox="0 0 200 104" preserveAspectRatio="none">' +
      '<path d="M8,' + top + ' L8,' + ye + ' Q100,' + (yc - 4) + ' 192,' + ye + ' L192,' + top + ' Z" ' +
        'fill="rgba(255,255,255,.9)"/>' +
      '<path d="M8,' + ye + ' Q100,' + (yc - 4) + ' 192,' + ye + '" fill="none" stroke="#FF7E00" stroke-width="3"/>' +
      '<line x1="8" y1="' + top + '" x2="192" y2="' + top + '" stroke="#0c2c57" stroke-width="3"/>' +
      '<text x="100" y="' + (top - 8) + '" font-size="13" font-weight="700" fill="#113C74" ' +
        'text-anchor="middle">' + t.c + '"</text>' +
      '<text x="20" y="' + (ye - 6) + '" font-size="11" font-weight="700" fill="#e6edf7">' + t.e + '"</text>' +
      '</svg>';
  }

  function chip(o, sel) {
    return '<button type="button" class="chip' + (o.id === sel ? ' on' : '') + '" data-id="' + o.id + '">' +
      o.name + (o.note || o.add ? '<small>' + (o.note ? o.note : '') +
      (o.add ? (o.note ? ' · ' : '') + plus(o.add) : '') + '</small>' : '') + '</button>';
  }

  function paintChips(id, list, sel) {
    $(id).innerHTML = list.map(function (o) { return chip(o, sel); }).join('');
  }

  function paintStraps() {
    $('straps').innerHTML = STRAPS.map(function (o) {
      return '<button type="button" class="chip' + (o.id === S.straps ? ' on' : '') +
        '" data-id="' + o.id + '">' + o.name + '<small>' + o.note + '</small></button>';
    }).join('');
  }

  function paintMaterials() {
    var mat = find(MATERIALS, S.material);
    $('mats').innerHTML = MATERIALS.map(function (m) {
      return '<button type="button" class="mat' + (m.id === S.material ? ' on' : '') + '" data-id="' + m.id + '">' +
        m.name + (m.add ? ' · ' + plus(m.add) : '') + '</button>';
    }).join('');
    $('wspot').hidden = S.material !== 'weathershield';
    $('swatches').innerHTML = mat.colors.map(function (c) {
      return '<div class="c' + (c.id === S.color ? ' on' : '') + '" data-id="' + c.id +
        '" role="button" tabindex="0"><i style="background:' + c.hex + '"></i><span>' + c.name + '</span></div>';
    }).join('');
  }

  function paintFolds() {
    $('fold').innerHTML = FOLDS.map(function (f) {
      var vert = f.axis === 'b';
      return '<div class="fold' + (f.id === S.fold ? ' on' : '') + '" data-id="' + f.id +
        '" role="button" tabindex="0">' +
        '<svg width="80" height="52" viewBox="0 0 80 52" aria-hidden="true">' +
        '<rect x="4" y="6" width="72" height="40" rx="5" fill="#e9eff7" stroke="#113C74" stroke-width="2"/>' +
        (vert
          ? '<line x1="40" y1="6" x2="40" y2="46" stroke="#FF7E00" stroke-width="3" stroke-dasharray="6 4"/>'
          : '<line x1="4" y1="26" x2="76" y2="26" stroke="#FF7E00" stroke-width="3" stroke-dasharray="6 4"/>') +
        '</svg><b>' + f.name + '</b><small>' + f.note + '</small></div>';
    }).join('');
  }

  function paintLifters() {
    $('lifters').innerHTML = LIFTERS.map(function (l) {
      return '<div class="lift' + (l.id === S.lifter ? ' on' : '') + '" data-id="' + l.id +
        '" role="button" tabindex="0" aria-pressed="' + (l.id === S.lifter) + '">' +
        '<div class="lift-img"><img src="' + l.art + '" alt="' + l.name + '" loading="lazy"></div>' +
        '<div class="lift-b"><div class="lift-n">' + l.name + '</div>' +
        '<div class="lift-p">' + (l.price ? money(l.price) : 'No charge') + '</div>' +
        '<div class="lift-d">' + l.desc +
        (l.url ? '<br><a class="lift-link" href="' + l.url + '" target="_blank" rel="noopener">View details</a>' : '') +
        '</div>' +
        '<div class="lift-cta">' + (l.id === S.lifter ? 'Selected' : 'Select') + '</div></div></div>';
    }).join('');
  }

  function paintIncluded() {
    $('inclAll').innerHTML = INCLUDED.map(function (t) { return '<i>' + t + '</i>'; }).join('');
  }

  /* --------------------------------------------------------------- preview */

  function paintPreview() {
    var shape = find(SHAPES, S.shape);
    var a = S.a, b = shape.lockB ? S.a : S.b;
    var pad = 30, boxW = 320 - pad * 2, boxH = 300 - pad * 2;
    var scale = Math.min(boxW / a, boxH / b);
    var w = a * scale, h = b * scale;
    var x = (320 - w) / 2, y = (300 - h) / 2;
    var mat = find(MATERIALS, S.material);
    var col = (function () {
      for (var i = 0; i < mat.colors.length; i++) if (mat.colors[i].id === S.color) return mat.colors[i].hex;
      return mat.colors[0].hex;
    })();

    var body;
    if (S.shape === 'round') {
      body = '<circle cx="160" cy="150" r="' + (w / 2) + '" fill="' + col + '" stroke="#0c2c57" stroke-width="2"/>';
    } else if (S.shape === 'octagon') {
      var cx = 160, cy = 150, rx = w / 2, ry = h / 2, k = 0.415, pts = [
        [cx - rx * k, cy - ry], [cx + rx * k, cy - ry], [cx + rx, cy - ry * k],
        [cx + rx, cy + ry * k], [cx + rx * k, cy + ry], [cx - rx * k, cy + ry],
        [cx - rx, cy + ry * k], [cx - rx, cy - ry * k]
      ].map(function (p) { return p[0].toFixed(1) + ',' + p[1].toFixed(1); }).join(' ');
      body = '<polygon points="' + pts + '" fill="' + col + '" stroke="#0c2c57" stroke-width="2"/>';
    } else {
      var r = shape.radius ? Math.min(S.rad * scale, Math.min(w, h) / 2) : 0;
      body = '<rect x="' + x.toFixed(1) + '" y="' + y.toFixed(1) + '" width="' + w.toFixed(1) +
        '" height="' + h.toFixed(1) + '" rx="' + r.toFixed(1) + '" fill="' + col +
        '" stroke="#0c2c57" stroke-width="2"/>';
    }

    // fold line
    var vert = find(FOLDS, S.fold).axis === 'b';
    var fold = vert
      ? '<line x1="160" y1="' + y + '" x2="160" y2="' + (y + h) + '"'
      : '<line x1="' + x + '" y1="150" x2="' + (x + w) + '" y2="150"';
    fold += ' stroke="#ffffff" stroke-width="3" stroke-dasharray="8 6" opacity=".85"/>';

    // handles, split evenly down the two sides parallel to the fold
    var hc = find(HANDLES, S.handles).count, per = hc / 2, hs = '', i, t;
    for (i = 0; i < per; i++) {
      t = (i + 1) / (per + 1);
      if (vert) {
        hs += hrect(x + w * t - 9, y + 5, 18, 7) + hrect(x + w * t - 9, y + h - 12, 18, 7);
      } else {
        hs += hrect(x + 5, y + h * t - 9, 7, 18) + hrect(x + w - 12, y + h * t - 9, 7, 18);
      }
    }

    // straps: either one centred on each named side, or one at each corner
    var layout = find(STRAPS, S.straps);
    var on = function (letter) { return !!layout.sides && layout.sides.indexOf(letter) !== -1; };
    var st = '';
    if (layout.corners) {
      st += sline(x + 14, y + 6, x - 8, y - 12);
      st += sline(x + w - 14, y + 6, x + w + 8, y - 12);
      st += sline(x + 14, y + h - 6, x - 8, y + h + 12);
      st += sline(x + w - 14, y + h - 6, x + w + 8, y + h + 12);
    } else {
      [0.3, 0.7].forEach(function (t) {
        if (on('A')) st += sline(x + w * t, y, x + w * t, y - 12);
        if (on('C')) st += sline(x + w * t, y + h, x + w * t, y + h + 12);
        if (on('B')) st += sline(x + w, y + h * t, x + w + 12, y + h * t);
        if (on('D')) st += sline(x, y + h * t, x - 12, y + h * t);
      });
    }

    // side letters, so the option labels map onto something visible
    var side = function (px, py, letter) {
      return '<text x="' + px + '" y="' + py + '" font-size="12" font-weight="700" text-anchor="middle" ' +
        'fill="' + (on(letter) ? '#FF7E00' : '#98a2b0') + '">' + letter + '</text>';
    };

    $('stage').innerHTML = body + fold + hs + st +
      side(160, y - 16, 'A') +
      side(x + w + 20, 154, 'B') +
      side(160, y + h + 26, 'C') +
      side(x - 20, 154, 'D');
  }

  function hrect(x, y, w, h) {
    return '<rect x="' + x.toFixed(1) + '" y="' + y.toFixed(1) + '" width="' + w + '" height="' + h +
      '" rx="2.5" fill="#ffffff" opacity=".9"/>';
  }
  function sline(x1, y1, x2, y2) {
    return '<line x1="' + x1.toFixed(1) + '" y1="' + y1.toFixed(1) + '" x2="' + x2.toFixed(1) +
      '" y2="' + y2.toFixed(1) + '" stroke="#FF7E00" stroke-width="3.5" stroke-linecap="round"/>';
  }

  /* ------------------------------------------------------------ validation */

  function dimIssues() {
    var shape = find(SHAPES, S.shape);
    var b = shape.lockB ? S.a : S.b;
    var out = [];
    if (!(S.a >= 30 && S.a <= 240)) out.push('Width A must be between 30" and 240".');
    if (!(b >= 30 && b <= 240)) out.push('Depth B must be between 30" and 240".');
    if (shape.radius && !(S.rad >= 0 && S.rad <= 24)) out.push('Corner radius must be between 0" and 24".');
    if (shape.radius && S.rad * 2 > Math.min(S.a, b)) out.push('Corner radius is too large for those dimensions.');
    return out;
  }

  function paintWarn() {
    var shape = find(SHAPES, S.shape);
    var b = shape.lockB ? S.a : S.b;
    var bad = dimIssues();
    if (bad.length) {
      $('dimWarn').innerHTML = '<div class="warn bad">' + bad.join(' ') + '</div>';
      return;
    }
    var tier2 = sizeTier();
    if (tier2.key) {
      $('dimWarn').innerHTML = '<div class="warn">At ' + Math.max(S.a, b) + '" across, this is an ' +
        '<strong>oversize cover</strong> — past 94" it cannot be cut from a single sheet, so it is built in ' +
        tier2.pieces + ' pieces and carries a <strong>' + money(tier2.fee) + '</strong> size surcharge. ' +
        'That is already in the total.</div>';
      return;
    }

    var ratio = Math.max(S.a, b) / Math.min(S.a, b);
    if (ratio > 2.4) {
      $('dimWarn').innerHTML = '<div class="warn">That is a long, narrow cover. A single piece that size gets ' +
        'heavy and awkward to lift — call <strong>1-888-946-8882</strong> and we will quote it as a ' +
        'two-piece cover instead.</div>';
      return;
    }
    $('dimWarn').innerHTML = '<div class="warn good">' + S.a + '" × ' + b +
      '" is within our standard build range — about ' + areaSqFt().toFixed(1) + ' sq ft of cover.</div>';
  }

  function paintCutoutNote() {
    $('cutoutNote').innerHTML = S.cutouts
      ? '<div class="warn">We will call you to confirm cut-out placement before production. ' +
        'Cut-outs are quoted separately and are <strong>not included in the estimate below</strong>.</div>'
      : '';
  }

  /* --------------------------------------------------------------- summary */

  function paintSummary() {
    var shape = find(SHAPES, S.shape), p = priceLines();
    var b = shape.lockB ? S.a : S.b;
    var mat = find(MATERIALS, S.material);
    var color = (function () {
      for (var i = 0; i < mat.colors.length; i++) if (mat.colors[i].id === S.color) return mat.colors[i];
      return mat.colors[0];
    })();
    var taper = find(TAPERS, S.taper), den = find(DENSITY, S.density);
    var vap = find(VAPOR, S.vapor), stop = find(STOPPER, S.stopper), han = find(HANDLES, S.handles);
    var fold = find(FOLDS, S.fold), del = find(DELIVERY, S.delivery);
    var strap = find(STRAPS, S.straps);
    var lift = currentLifter();

    var v = function (id, txt) { $(id).innerHTML = txt; };
    v('s1', shape.name + ' · ' + S.a + '" × ' + b + '"' + (shape.radius ? ' · R' + S.rad + '"' : ''));
    v('sBase', money(p.base));
    var tier = sizeTier();
    $('sOverRow').style.display = p.oversize ? 'flex' : 'none';
    if (p.oversize) v('sOver', tier.label + ' <em>' + plus(p.oversize) + '</em>');
    v('sSkirt', S.skirt + '"' + (p.skirt ? ' <em>' + plus(p.skirt) + '</em>' : ' <em>Included</em>'));
    v('sTaper', taper.name + (p.taper ? ' <em>' + plus(p.taper) + '</em>' : ''));
    v('sDen', den.name + (p.density ? ' <em>' + plus(p.density) + '</em>' : ''));
    v('sMat', mat.name + ' · ' + color.name + (p.material ? ' <em>' + plus(p.material) + '</em>' : ''));
    v('sVap', vap.name + (p.vapor ? ' <em>' + plus(p.vapor) + '</em>' : ''));
    v('sStop', stop.name + (p.stopper ? ' <em>' + plus(p.stopper) + '</em>' : ''));
    v('sHand', han.name + (p.handles ? ' <em>' + plus(p.handles) + '</em>' : ''));
    v('sFold', fold.name + ' · ' + strap.name + ' · 9.5"');
    v('sDel', del.name + ' (' + del.note + ')' + (p.delivery ? ' <em>' + plus(p.delivery) + '</em>' : ''));

    $('sUpRow').style.display = lift ? 'flex' : 'none';
    if (lift) v('sUp', lift.name + ' <em>' + money(lift.price) + '</em>');

    var t = total();
    $('total').textContent = money(t);
    $('finance').innerHTML = 'From <strong>' + money(t / 12) + '/mo</strong> over 12 months with Shop Pay Installments.';
    $('fine').textContent = 'Estimate only. Skirt ' + S.skirt + '", ' + del.note +
      ' production. Final price is confirmed on your order acknowledgement.';

    // step header chips
    $('sel-shape').textContent = shape.name;
    $('sel-dims').textContent = S.a + '" × ' + b + '"';
    $('sel-foam').textContent = taper.name.replace(/"/g, '"') + ' · ' + den.name;
    $('sel-color').textContent = color.name;
    $('sel-prot').textContent = (S.vapor === 'std' && S.stopper === 'std' && S.handles === 'std')
      ? 'Standard' : [vap.name, stop.name + ' stopper', han.name].join(' · ');
    $('sel-fold').textContent = fold.name + ' · ' + strap.name;
    $('sel-ups').textContent = del.name;
    $('sel-lift').textContent = lift ? lift.name : 'None';
    $('pvDims').textContent = S.a + '" × ' + b + '"';
  }

  function paintGates() {
    $('cutoutWrap').classList.toggle('on', S.cutouts);
    $('confirmWrap').classList.toggle('on', S.okDims);
    $('returnsWrap').classList.toggle('on', S.okReturns);
    if (S.okDims) $('confirmWrap').classList.remove('miss');
    if (S.okReturns) $('returnsWrap').classList.remove('miss');
    var ready = S.okDims && S.okReturns && !dimIssues().length;
    $('atc').disabled = !ready;
    $('atc').textContent = ready ? 'Add to cart — ' + money(total())
      : (dimIssues().length ? 'Check your measurements' : 'Confirm your measurements to continue');

    /* The mobile bar stays enabled even when the form isn't ready — tapping it
       scrolls back up to whatever is missing, which a disabled button can't do. */
    if ($('mTotal')) $('mTotal').textContent = money(total());
    if ($('mAtc')) $('mAtc').textContent = ready ? 'Add to cart' : 'Review specs';
  }

  /* ----------------------------------------------------------------- paint */

  function update() {
    var shape = find(SHAPES, S.shape);
    $('radWrap').style.display = shape.radius ? '' : 'none';
    $('dimB').disabled = !!shape.lockB;
    if (shape.lockB) { S.b = S.a; $('dimB').value = S.a; }
    paintWarn();
    paintCutoutNote();
    paintPreview();
    paintSummary();
    paintGates();
  }

  function paintAll() {
    paintShapes(); paintTapers();
    paintChips('density', DENSITY, S.density);
    paintMaterials();
    paintChips('vapor', VAPOR, S.vapor);
    paintChips('stopper', STOPPER, S.stopper);
    paintChips('handles', HANDLES, S.handles);
    paintFolds();
    paintStraps();
    paintChips('delivery', DELIVERY, S.delivery);
    paintIncluded();
    paintLifters();
    update();
  }

  /* ----------------------------------------------------------------- wires */

  /* One delegated click handler per option container. `after` lets a group
     repaint the things its choice changes. */
  function pick(containerId, selector, key, repaint) {
    var el = $(containerId);
    var handler = function (ev) {
      var hit = ev.target.closest ? ev.target.closest(selector) : null;
      if (!hit || !el.contains(hit)) return;
      S[key] = hit.getAttribute('data-id');
      (repaint || function () {})();
      update();
    };
    el.addEventListener('click', handler);
    el.addEventListener('keydown', function (ev) {
      if (ev.key === 'Enter' || ev.key === ' ') { ev.preventDefault(); handler(ev); }
    });
  }

  /* Runs once, when the shape is chosen. A rectangle with equal sides is a
     square and the preview would look wrong, so give the depth a real ratio —
     but never touch a number the customer typed themselves. */
  function applyShapeDefaults() {
    var shape = find(SHAPES, S.shape);
    if (shape.oblong && S.a === S.b) {
      S.b = Math.round(S.a * 0.72);
      $('dimB').value = S.b;
    }
  }

  pick('shapes', '.shape', 'shape', function () { applyShapeDefaults(); paintShapes(); });
  pick('tapers', '.tp', 'taper', paintTapers);
  pick('density', '.chip', 'density', function () { paintChips('density', DENSITY, S.density); });
  pick('vapor', '.chip', 'vapor', function () { paintChips('vapor', VAPOR, S.vapor); });
  pick('stopper', '.chip', 'stopper', function () { paintChips('stopper', STOPPER, S.stopper); });
  pick('handles', '.chip', 'handles', function () { paintChips('handles', HANDLES, S.handles); });
  pick('fold', '.fold', 'fold', paintFolds);
  pick('straps', '.chip', 'straps', paintStraps);
  pick('delivery', '.chip', 'delivery', function () { paintChips('delivery', DELIVERY, S.delivery); });
  /* Lifters toggle: there is no "none" card, so tapping the selected one clears
     it. That is how a customer says "actually, I don't want a lifter". */
  $('lifters').addEventListener('click', function (ev) {
    if (ev.target.closest('.lift-link')) return;   // let the product link through
    var hit = ev.target.closest('.lift');
    if (!hit) return;
    var id = hit.getAttribute('data-id');
    S.lifter = (S.lifter === id) ? null : id;
    paintLifters();
    update();
  });
  pick('swatches', '.c', 'color', paintMaterials);

  // material also resets the colour to that material's first swatch
  $('mats').addEventListener('click', function (ev) {
    var hit = ev.target.closest('.mat');
    if (!hit) return;
    S.material = hit.getAttribute('data-id');
    S.color = find(MATERIALS, S.material).colors[0].id;
    paintMaterials();
    update();
  });

  var num = function (id, key, dflt) {
    $(id).addEventListener('input', function () {
      var n = parseFloat(this.value);
      S[key] = isNaN(n) ? dflt : n;
      update();
    });
  };
  num('dimA', 'a', 84);
  num('dimB', 'b', 84);
  num('rad', 'rad', 6);

  $('skirt').addEventListener('change', function () { S.skirt = parseFloat(this.value); update(); });
  $('cutouts').addEventListener('change', function () { S.cutouts = this.checked; update(); });
  $('confirmDims').addEventListener('change', function () { S.okDims = this.checked; update(); });
  $('confirmReturns').addEventListener('change', function () { S.okReturns = this.checked; update(); });

  /* ---------------------------------------------------------------- modals */

  function openModal(el) { el.classList.add('on'); document.body.style.overflow = 'hidden'; }
  function closeModal(el) { el.classList.remove('on'); document.body.style.overflow = ''; }

  $('openGuide').addEventListener('click', function () { openModal($('guide')); });
  $('closeGuide').addEventListener('click', function () { closeModal($('guide')); });
  $('closeCmp').addEventListener('click', function () { closeModal($('cmp')); });

  [$('guide'), $('cmp')].forEach(function (m) {
    m.addEventListener('click', function (ev) { if (ev.target === m) closeModal(m); });
  });
  document.addEventListener('keydown', function (ev) {
    if (ev.key !== 'Escape') return;
    closeModal($('guide')); closeModal($('cmp'));
  });

  Array.prototype.forEach.call(document.querySelectorAll('.cmp-btn[data-cmp]'), function (btn) {
    btn.addEventListener('click', function () {
      var c = COMPARE[btn.getAttribute('data-cmp')];
      if (!c) return;
      $('cmpTitle').textContent = c.title;
      $('cmpBody').innerHTML = c.items.map(function (i) {
        return '<div class="cmp-i">' + i.art + '<div class="b"><h5>' + i.h + '</h5><p>' + i.p + '</p></div></div>';
      }).join('');
      openModal($('cmp'));
    });
  });

  /* ------------------------------------------------------------ add to cart */

  /* Builds the line-item properties that go on the order. In a live theme,
     set window.MSCB_VARIANT_ID to the custom-cover variant and this POSTs to
     /cart/add.js. Without it, the spec is logged and echoed in an alert so
     the section is testable on a static page. */
  function specProperties() {
    var shape = find(SHAPES, S.shape);
    var b = shape.lockB ? S.a : S.b;
    var mat = find(MATERIALS, S.material);
    var color = (function () {
      for (var i = 0; i < mat.colors.length; i++) if (mat.colors[i].id === S.color) return mat.colors[i];
      return mat.colors[0];
    })();
    var props = {
      'Shape': shape.name,
      'Size (A × B)': S.a + '" × ' + b + '"',
      'Skirt': S.skirt + '"',
      'Size tier': (function () { var t = sizeTier(); return t.key ? t.label + ' (' + t.pieces + '-piece)' : 'Standard size'; })(),
      'Taper': find(TAPERS, S.taper).name,
      'Foam density': find(DENSITY, S.density).name,
      'Material': mat.name,
      'Color': color.name,
      'Vapor barrier': find(VAPOR, S.vapor).name,
      'Steam stopper': find(STOPPER, S.stopper).name,
      'Handles': find(HANDLES, S.handles).name,
      'Fold': find(FOLDS, S.fold).name,
      'Straps': (function () { var o = find(STRAPS, S.straps); return o.name + ' — ' + o.note + ', 9.5"'; })(),
      'Delivery': find(DELIVERY, S.delivery).name + ' (' + find(DELIVERY, S.delivery).note + ')',
      'Dimensions confirmed by customer': 'Yes',
      'Non-returnable acknowledged': 'Yes'
    };
    if (shape.radius) props['Corner radius'] = S.rad + '"';
    if (S.cutouts) props['Cut-outs'] = 'Yes — confirm placement before production';
    var cl = currentLifter();
    if (cl) props['Cover lifter'] = cl.name;
    return props;
  }

  function attemptAdd(btn) {
    if (!S.okDims) $('confirmWrap').classList.add('miss');
    if (!S.okReturns) $('returnsWrap').classList.add('miss');
    if (!S.okDims || !S.okReturns || dimIssues().length) {
      $('stepDims').scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    var props = specProperties();
    /* The cover's own variant is chosen by taper tier; MSCB_VARIANT_ID stays
       supported as a manual override. */
    var vid = window.MSCB_VARIANT_ID || SHOP.taperVariant[S.taper];

    /* Off-storefront (the standalone preview file) there is no cart to post to,
       so dump the spec instead of firing a request that cannot succeed. */
    var onShopify = !!(window.Shopify && window.Shopify.shop) || livePricesLoaded;
    if (!onShopify || !vid) {
      console.log('[cover-builder] spec', props, 'estimated total', total());
      alert('Custom cover spec (' + money(total()) + ' est.)\n\n' +
        Object.keys(props).map(function (k) { return k + ': ' + props[k]; }).join('\n') +
        '\n\nPreview only — no Shopify cart on this page.');
      return;
    }

    /* Refuse rather than undercharge. If a paid upgrade has no variant id, the
       line would be dropped from the cart while the spec still promised it —
       the customer gets it free and the order looks correct to the rep. Fail
       loudly instead; MSCB.audit() names the offending options. */
    var unwired = chosenUpgrades().filter(function (u) { return !SHOP.upgradeVariant[u.key]; });
    if (unwired.length) {
      console.error('[cover-builder] BLOCKED — these options have no Shopify variant id:',
        unwired.map(function (u) { return u.key; }).join(', '),
        '\nRun MSCB.audit() and fill them in before selling.');
      alert('Sorry — this combination can\u2019t be ordered online just yet.\n\n' +
        'Please call 1-888-946-8882 and we\u2019ll build the quote with you.');
      return;
    }


    /* One request, several line items: the cover on its chosen taper variant,
       one line per paid upgrade, and the lifter. Every line carries _Build so a
       rep can see at a glance which lines belong to the same cover. */
    var lift = currentLifter();
    var buildRef = 'Cover ' + props['Size (A × B)'];
    props['_Build'] = buildRef;

    var items = [{ id: vid, quantity: 1, properties: props }];

    chosenUpgrades().forEach(function (u) {
      var id = SHOP.upgradeVariant[u.key];
      if (id) items.push({ id: id, quantity: 1, properties: { '_Build': buildRef } });
    });

    if (lift && lift.variantId) items.push({ id: lift.variantId, quantity: 1 });

    var label = btn.textContent;
    btn.disabled = true; btn.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart/add returned ' + r.status);
      window.location.href = '/cart';
    }).catch(function (err) {
      console.error('[cover-builder]', err);
      btn.disabled = false;
      btn.textContent = label;
      alert('Sorry — we could not add that to your cart. Please try again or call 1-888-946-8882.');
    });
  }

  $('atc').addEventListener('click', function () { attemptAdd(this); });
  if ($('mAtc')) $('mAtc').addEventListener('click', function () { attemptAdd(this); });

  /* Wiring check. Open the section on the storefront and run MSCB.audit() in the
     browser console: it lists every option, the variant it points at, and the
     price Shopify returned — so a missing or mistyped id is impossible to miss. */
  window.MSCB = {
    shop: SHOP,
    live: LIVE,
    state: S,
    priceLines: priceLines,
    total: total,
    audit: function () {
      var rows = [];
      Object.keys(SHOP.taperVariant).forEach(function (k) {
        var id = SHOP.taperVariant[k];
        rows.push({ option: 'cover / taper ' + k, variant: id,
          shopifyPrice: LIVE[id] != null ? money(LIVE[id]) : 'NOT FOUND' });
      });
      Object.keys(SHOP.upgradeVariant).forEach(function (k) {
        var id = SHOP.upgradeVariant[k];
        rows.push({ option: k, variant: id || '(not set)',
          shopifyPrice: !id ? 'ESTIMATE — id missing'
            : (LIVE[id] != null ? money(LIVE[id]) : 'NOT FOUND') });
      });
      LIFTERS.forEach(function (l) {
        rows.push({ option: 'lifter / ' + l.id, variant: l.variantId,
          shopifyPrice: LIVE[l.variantId] != null ? money(LIVE[l.variantId]) : 'NOT FOUND' });
      });
      if (console.table) console.table(rows);
      var bad = rows.filter(function (r) { return r.shopifyPrice.charAt(0) !== '$'; });
      console.log(bad.length
        ? '\u26a0 ' + bad.length + ' of ' + rows.length + ' options are NOT priced by Shopify — fix before launch'
        : '\u2713 all ' + rows.length + ' options priced live by Shopify');
      console.log('badge says: ' + ($('priceMode') ? $('priceMode').textContent : 'n/a') +
        '  |  builder total right now: ' + money(total()));
      return rows;
    }
  };

  paintAll();
  loadLivePrices();
})();